import React, { useEffect, useState } from 'react';
import { BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs';
import { useHistory } from 'react-router-dom';

import { saveOnBoardData } from 'api/onBoarding';
import InputField from 'components/FormFields/InputField';
import LocationSelect from 'components/LocationSelect';
import APFormGroup from 'components/FormFields/APFormGroup';
import { prepareLocationForApi } from 'utils/location';
import { getPutFormat } from './filter';
import './styles.scss';

// Converts the address model to google place like object.
const formatAddress = (address) => {
  const { city, country, postcode, state, street_line_1 } = address;
  if ((city === '' && state === '') || (city === ' ' && state === ' ')) {
    return null;
  }
  let formattedAddress = '';
  if (street_line_1) formattedAddress += `${street_line_1}, `;
  if (city) formattedAddress += `${city}, `;
  if (state) formattedAddress += `${state} `;
  if (postcode) formattedAddress += `${postcode}`;
  if (country) formattedAddress += `, ${country}`;
  return { ...address, formattedAddress };
};

const Step3 = ({ formData, setLocation }) => {
  const history = useHistory();
  const [isSubmitted, setFormSubmitted] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [businessAddress, setBusinessAddress] = useState();

  useEffect(() => {
    const { companyInfo } = formData;
    if (companyInfo) {
      const { businessAddress: address, companyName: cName } = companyInfo;
      setCompanyName(cName || '');
      const updatedAddress = formatAddress(address);
      setBusinessAddress(updatedAddress);
    }
  }, [formData]);

  const isFormFieldsValid = () => !!companyName && !!businessAddress;

  const saveForms = async () => {
    const newFormData = formData;
    newFormData.companyInfo.companyName = companyName;
    if (businessAddress) {
      newFormData.companyInfo.businessAddress = prepareLocationForApi(businessAddress);
    } else {
      newFormData.companyInfo.businessAddress = {};
    }

    const result = await saveOnBoardData({ boarding: getPutFormat(newFormData) });
    return result;
  };

  const handleBack = () => {
    history.push('/app/v2/account-setup/step/2');
  };

  const handleNext = async () => {
    setLocation(businessAddress);
    setFormSubmitted(true);
    if (isFormFieldsValid()) {
      const response = await saveForms();
      if (response) history.push('/app/v2/account-setup/step/4');
    }
  };

  return (
    <>
      <section className="stepflow_content">
        <article className="stepflow_form">
          <section className="stepflow_form-header">
            <h3 className="form-title">Company profile</h3>
            <p className="form-subtitle text-center">
              We'll use this information to populate everything from your
              company settings to your quote and invoice templates. Our promise
              to you—we won't sell, trade or abuse any information you submit to
              us.
            </p>
          </section>
          <APFormGroup
            verticalGap={0}
          >
            <InputField
              name="companyName"
              label="Company Name"
              value={companyName}
              required
              onChange={(e) => {
                setCompanyName(e.target.value);
              }}
              showError={isSubmitted && !companyName}
            />
          </APFormGroup>
          <APFormGroup>
            <LocationSelect
              location={businessAddress}
              setLocation={setBusinessAddress}
              name="Business Address"
              placeholder="Please enter your street address and choose from the options below."
              required
              error={isSubmitted && !businessAddress}
            />
          </APFormGroup>
        </article>
      </section>
      <section className="stepflow_footer">
        <button className="stepflow_footer-button"
          onClick={handleBack}
        >
          <BsArrowLeftShort size={20} /> Back
        </button>
        {isSubmitted && !isFormFieldsValid() && (
          <div className="stepflow_footer-error">
            Please complete required fields above.
          </div>
        )}
        <button
          className="stepflow_footer-button"
          color="primary"
          onClick={handleNext}
        >
          Next
          <BsArrowRightShort size={20} />
        </button>
      </section>
    </>
  );
};

export default Step3;
